import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import * as Feather from "feather-icons";

/**
 * Pipe pour afficher les icônes Feather dans les templates dynamiques
 * Usage: {{ 'icon-name' | featherIcon }} ou {{ 'icon-name' | featherIcon:16 }} ou {{ 'icon-name' | featherIcon:16:'text-white' }}
 */
@Pipe({
  name: "featherIcon",
})
export class FeatherIconPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(iconName: string, size: number = 14, cssClass: string = ""): SafeHtml {
    if (!iconName || !Feather.icons[iconName]) {
      console.warn(`Feather icon "${iconName}" not found`);
      // Retourner une icône par défaut si non trouvée
      iconName = "help-circle";
    }

    try {
      const svg = Feather.icons[iconName].toSvg({
        class: cssClass,
        width: size,
        height: size,
      });
      return this.sanitizer.bypassSecurityTrustHtml(svg);
    } catch (error) {
      console.error(`Error rendering Feather icon "${iconName}":`, error);
      return "";
    }
  }
}
